/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ImportacaoFontesSeladasAutorizacaoFormDto } from '../models/importacao-fontes-seladas-autorizacao-form-dto';
import { ImportacaoFontesSeladasCriteriaDto } from '../models/importacao-fontes-seladas-criteria-dto';
import { ImportacaoFontesSeladasDeclaracaoEuratomFormDto } from '../models/importacao-fontes-seladas-declaracao-euratom-form-dto';
import { ImportacaoFontesSeladasDto } from '../models/importacao-fontes-seladas-dto';
import { ImportacaoFontesSeladasFormDto } from '../models/importacao-fontes-seladas-form-dto';
import { ImportacaoFontesSeladasPageDto } from '../models/importacao-fontes-seladas-page-dto';
import { ImportacaoFontesSeladasSummaryDto } from '../models/importacao-fontes-seladas-summary-dto';


/**
 * Importação Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class ImportacaoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPedidosImpFs
   */
  static readonly GetPedidosImpFsPath = '/importacao-fontes-seladas';

  /**
   * Pesquisar Importacoes Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidosImpFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidosImpFs$Response(params?: {
    criteria?: ImportacaoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<ImportacaoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.GetPedidosImpFsPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Importacoes Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidosImpFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidosImpFs(params?: {
    criteria?: ImportacaoFontesSeladasCriteriaDto;
  }): Observable<ImportacaoFontesSeladasPageDto> {

    return this.getPedidosImpFs$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesSeladasPageDto>) => r.body as ImportacaoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation submeterImpFs
   */
  static readonly SubmeterImpFsPath = '/importacao-fontes-seladas';

  /**
   * Submeter Pedido de Enquadramento Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterImpFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterImpFs$Response(params?: {
    body?: {
'impFSForm'?: ImportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'pecasDesenhadas'?: Array<Blob>;
'certFonte'?: Array<Blob>;
'comprovativoValor'?: Array<Blob>;
'contratoDevolucao'?: Array<Blob>;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.SubmeterImpFsPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Submeter Pedido de Enquadramento Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterImpFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  submeterImpFs(params?: {
    body?: {
'impFSForm'?: ImportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'pecasDesenhadas'?: Array<Blob>;
'certFonte'?: Array<Blob>;
'comprovativoValor'?: Array<Blob>;
'contratoDevolucao'?: Array<Blob>;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<ImportacaoFontesSeladasSummaryDto> {

    return this.submeterImpFs$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>) => r.body as ImportacaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation getPedidoImpFs
   */
  static readonly GetPedidoImpFsPath = '/importacao-fontes-seladas/{id}';

  /**
   * Pesquisar Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPedidoImpFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoImpFs$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ImportacaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.GetPedidoImpFsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Pesquisar Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPedidoImpFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPedidoImpFs(params: {
    id: number;
  }): Observable<ImportacaoFontesSeladasDto> {

    return this.getPedidoImpFs$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesSeladasDto>) => r.body as ImportacaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateImpFs
   */
  static readonly UpdateImpFsPath = '/importacao-fontes-seladas/{id}';

  /**
   * Editar Pedido de Enquadramento Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateImpFs()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateImpFs$Response(params: {
    id: number;
    body?: {
'impFSForm'?: ImportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'pecasDesenhadas'?: Array<Blob>;
'certFonte'?: Array<Blob>;
'comprovativoValor'?: Array<Blob>;
'contratoDevolucao'?: Array<Blob>;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.UpdateImpFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar Pedido de Enquadramento Importacao Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateImpFs$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateImpFs(params: {
    id: number;
    body?: {
'impFSForm'?: ImportacaoFontesSeladasFormDto;
'copiaCertC7'?: Blob;
'copiaCertFormacao'?: Blob;
'certContentor'?: Blob;
'pecasDesenhadas'?: Array<Blob>;
'certFonte'?: Array<Blob>;
'comprovativoValor'?: Array<Blob>;
'contratoDevolucao'?: Array<Blob>;
'documentoFontesForaUso'?: Blob;
'acessoNaoAutorizado'?: Blob;
'copiaApoliceSeguro'?: Blob;
'declaracaoAtividadeAcumulada'?: Blob;
'planoEmergencia'?: Blob;
}
  }): Observable<ImportacaoFontesSeladasSummaryDto> {

    return this.updateImpFs$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>) => r.body as ImportacaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateAutorizacao
   */
  static readonly UpdateAutorizacaoPath = '/importacao-fontes-seladas/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido de fontes seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacao$Response(params: {
    id: number;
    body?: ImportacaoFontesSeladasAutorizacaoFormDto
  }): Observable<StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.UpdateAutorizacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido de fontes seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacao(params: {
    id: number;
    body?: ImportacaoFontesSeladasAutorizacaoFormDto
  }): Observable<ImportacaoFontesSeladasSummaryDto> {

    return this.updateAutorizacao$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>) => r.body as ImportacaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation updateEuratom
   */
  static readonly UpdateEuratomPath = '/importacao-fontes-seladas/{id}/declaracao-euratom';

  /**
   * Editar declaração euratom de um pedido de fonte selada.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEuratom()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEuratom$Response(params: {
    id: number;
    body?: ImportacaoFontesSeladasDeclaracaoEuratomFormDto
  }): Observable<StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.UpdateEuratomPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>;
      })
    );
  }

  /**
   * Editar declaração euratom de um pedido de fonte selada.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateEuratom$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEuratom(params: {
    id: number;
    body?: ImportacaoFontesSeladasDeclaracaoEuratomFormDto
  }): Observable<ImportacaoFontesSeladasSummaryDto> {

    return this.updateEuratom$Response(params).pipe(
      map((r: StrictHttpResponse<ImportacaoFontesSeladasSummaryDto>) => r.body as ImportacaoFontesSeladasSummaryDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoImportacao
   */
  static readonly PreviewDocAutorizacaoImportacaoPath = '/importacao-fontes-seladas/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoImportacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoImportacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.PreviewDocAutorizacaoImportacaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoImportacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoImportacao(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoImportacao$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation previewDocEuratom
   */
  static readonly PreviewDocEuratomPath = '/importacao-fontes-seladas/{id}/preview-doc-euratom';

  /**
   * Preview Documento Euratom.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocEuratom()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocEuratom$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ImportacaoFontesSeladasService.PreviewDocEuratomPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento Euratom.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocEuratom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocEuratom(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocEuratom$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
